import React, { useEffect } from 'react';

function isPWA() {
  return (
    (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true
  );
}

export default function ConfirmRegistrationBottomSheet({ eventName = '(Event)', onConfirm, onDismiss }) {

    useEffect(() => {
        const meta = document.querySelector('meta[name="theme-color"]');
        if (meta) meta.content = '#999998';       // darken notch / bar
        return () => {
          if (meta) meta.content = '#ffffff';     // restore on close
        };
      }, []);
      
  return (
    <div style={styles.backdrop} onClick={onDismiss}>
      <div
        style={{
          ...styles.sheetContainer,
          marginBottom: isPWA() ? 40 : 8,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={styles.imageWrapper}>
          <img
            src="/TicketCollageBackground.jpg"
            alt="Event Background"
            style={styles.backgroundImageStyle}
          />
          <div style={styles.iconCircle}>🎟️</div>
          <div style={styles.plusOneCircle}>+1</div>
        </div>
        <div style={styles.textWrapper}>
          <h2 style={styles.title}>Confirm Your Spot!</h2>
          <p style={styles.subtitle}>
            You're about to register for <strong>{eventName}</strong>. Confirm your spot to participate in this event!
          </p>
        </div>

        <div style={styles.buttonRow}>
          <button style={styles.dismissBtn} onClick={onDismiss}>
            Cancel
          </button>
          <button style={styles.confirmBtn} onClick={onConfirm}>
            Confirm
          </button>
        </div>
      </div>

      <style>
        {`
          @keyframes slideUp {
            from { transform: translateY(100%); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
        `}
      </style>
    </div>
  );
}

const styles = {
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    fontFamily: "'Open Sans', sans-serif",
  },
  sheetContainer: {
    width: '100%',
    maxWidth: 420,
    margin: '0 8px 8px',
    backgroundColor: '#fff',
    borderRadius: 12,
    animation: 'slideUp 0.3s ease-out',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 16px',
  },
  imageWrapper: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 20,
    padding: 16,
    borderRadius: 12,
    overflow: 'hidden',
    height: 200,
    backgroundColor: '#f7f7f7',
  },
  backgroundImageStyle: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    filter: 'grayscale(100%) opacity(0.2)',
    zIndex: 1,
  },
  iconCircle: {
    width: 150,
    height: 150,
    borderRadius: '50%',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '3rem',
    position: 'relative',
    zIndex: 2,
  },
  plusOneCircle: {
    position: 'absolute',
    top: '18%',
    right: '30%',
    width: 40,
    height: 40,
    borderRadius: '50%',
    backgroundColor: '#4285F4',
    color: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1rem',
    fontWeight: '700',
    zIndex: 3,
  },
  textWrapper: {
    textAlign: 'center',
    marginBottom: '20px',
  },
  title: {
    fontSize: '1.5rem',
    fontWeight: '700',
    margin: '0 0 8px',
    color: '#222222',
  },
  subtitle: {
    fontSize: '1rem',
    color: '#555555',
    margin: 0,
    marginBottom: 12,
  },
  buttonRow: {
    display: 'flex',
    gap: 12,
  },
  dismissBtn: {
    flex: 1,
    padding: '12px 0',
    backgroundColor: '#eeeeee',
    color: '#444444',
    border: 'none',
    borderRadius: 10,
    fontWeight: 600,
    cursor: 'pointer',
  },
  confirmBtn: {
    flex: 1,
    padding: '12px 0',
    backgroundColor: '#4285F4',
    color: '#ffffff',
    border: 'none',
    borderRadius: 10,
    fontWeight: 600,
    cursor: 'pointer',
  },
};